module.exports = __webpack_public_path__ + "static/media/wingate_collection05_2_0119.8b62d5df.jpg";